<template>
    <main-layout>
        <template #breadcrumbs>
            <span class="union-icon">
                <i class="feather-tag"></i>
            </span>
            <span class="repo-chart-title">
                <inertia-link :href="route('home')">
                    <span class="repo-text">Repositories</span>
                </inertia-link>
                <span class="d-line">/ </span>
                Create Helm Repository
            </span>
        </template>
        <template #pageTitle>
            <h2 class="mb-1">Create Helm Repository</h2>
            <span class="sm-text">Enter details of your new repository</span>
        </template>
        <create-team-form />
    </main-layout>
</template>

<script>
    import MainLayout from '@/Layouts/MainLayout'
    import CreateTeamForm from './CreateTeamForm'

    export default {
        components: {
            MainLayout,
            CreateTeamForm,
        },
    }
</script>
